import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _SocialSecurityTemplate } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../../editor/AccountEditor";
import { FileInput } from "../../../theme/Component/FileInput";
import { BasicButton } from "../../../theme/Component/BasicButton";


export const SocialSecurityTemplate = () => {

    const socialsec = useDataBean(_SocialSecurityTemplate);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [formato, setFormato] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalimportar, setModalimportar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalexport, setModalexport] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        socialsec.instance.getSocialSecurityTemplateCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        socialsec.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        socialsec.instance.deleteSocialSecurityTemplate(socialsec.bean.IDSocialSecurityTemplate).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        socialsec.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDSocialSecurityTemplate', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tercero', property: 'EmployeeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${socialsec.bean.Name}`, "view": true }) } },
            { titulo: 'Importar configuración del formato', icono: 'ri-upload-2-line', visible: single.canDelete(), evento: () => { setModalimportar({ ...modalimportar, "view": true }) } },
            { titulo: 'Exportar Seguridad Social', icono: 'ri-download-2-fill', visible: single.canDelete(), evento: () => { exportSocialSecurityTemplate() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const importSocialSecurityTemplate = () => {

        socialsec.instance.importSocialSecurityTemplate(socialsec.bean.IDSocialSecurityTemplate, socialsec.bean.Media, socialsec.bean.MediaContext, null).then(
            (resp) => {
                if (resp) {
                    setModalimportar({ ...modalimportar, "view": false });
                    toast.success('Importado');
                }


            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const exportSocialSecurityTemplate = () => {

        socialsec.instance.exportSocialSecurityTemplate(socialsec.bean.IDSocialSecurityTemplate).then(
            (resp) => {
                if (resp) {
                    setFormato(resp[0]);
                    setModalexport({ ...modalexport, "view": true })
                    toast.success('Exportado');
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const exportSocialSecurityTemplatetwo = () => {

        socialsec.instance.exportSocialSecurityTemplate(null).then(
            (resp) => {
                if (resp) {
                    setFormato(resp[0]);
                    setModalexport({ ...modalexport, "view": true })
                    toast.success('Exportado');
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }
    return (
        <BasicPage titulo="Formatos de Seguridad Social">
            <div className="row">
                <div className="col-md-6">
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={exportSocialSecurityTemplatetwo}>
                        Exportar Seguridad Social
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={socialsec.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={socialsec.bean.Name} onChange={socialsec.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-12">
                                <AccountEditor label="Tercero" idAccount={socialsec.bean.IDAccount} onChange={(e) => { socialsec.setBean({ ...socialsec.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalimportar} updateModal={setModalimportar} eventModal={importSocialSecurityTemplate}>
                        <div className="row">
                            <div className="col-md-12">
                                <FileInput
                                    Media={socialsec.bean.Media}
                                    MediaContext={socialsec.bean.MediaContext}
                                    directory='Configuracionformatos'
                                    label='Archivo'
                                    docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                    onCreate={(Filemap: any) => { socialsec.setBean({ ...socialsec.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                ></FileInput>
                            </div>
                        </div>
                    </Modal>
                    <div className="col-md-12">
                        <Modal modal={modalexport} updateModal={setModalexport}>
                            <div className="row">
                                {formato?.DataBeanProperties?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-6 mt-3">
                                            <a href={formato.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>{formato.DataBeanProperties.Filename}</strong>
                                            </a>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </Modal>
                    </div>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {socialsec.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}